<template>
  <div class="mt-2">
    <app-timeline-item variant="secondary">
      <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
        <h6>{{ cuatrimestre.temporalidad }} {{ cuatrimestre.periodo }}</h6>
        <b-badge
          pill
          variant="light-info"
          style="cursor: pointer;"
          @click="getmaterias(cuatrimestre);shwMaterias =! shwMaterias"
        >
          {{ (!shwMaterias) ? 'Ver' : 'Ocultar' }} materias
        </b-badge>
      </div>
      <!-- list materias -->
      <b-overlay
        :show="load_mat"
        rounded="sm"
      >
        <materia
          v-for="mat in materias"
          v-show="shwMaterias"
          :key="mat.curso_id"
          :materia="mat"
          :periodo="cuatrimestre.periodo"
        />
      </b-overlay>
    </app-timeline-item>

  </div>
</template>

<script>
import {
  BBadge, BOverlay,
} from 'bootstrap-vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import materia from './Materias.vue'

export default {
  components: {
    AppTimelineItem,
    BBadge,
    BOverlay,
    materia,
  },
  props: {
    cuatrimestre: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      load_mat: false,
      shwMaterias: false,
      parciales: [],
      materias: [],
    }
  },
  created() {

  },
  methods: {
    getmaterias(cuat) {
      if (cuat.materias.length > 0) {
        this.load_mat = true
        const delayInMilliseconds = 1000 // 1 second
        this.materias = []
        setTimeout(() => {
          this.materias = cuat.materias
          this.load_mat = false
        }, delayInMilliseconds)
      }
    },
  },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
li {
  list-style: none;
}
</style>
